var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11594 1.68494L1.12066 1.67441C1.31996 1.2393 1.71509 1 2.10961 1H24.8934C25.2919 1 25.6868 1.24181 25.8842 1.68397L25.8842 1.68397L25.8865 1.6891C26.0856 2.12837 26.0197 2.63908 25.7143 3.00364L25.7011 3.01944L25.6885 3.03578L16.0845 15.5122L15.8769 15.7818V16.1221V23.215C15.8769 23.5436 15.7028 23.808 15.4791 23.9253L15.4757 23.9271C15.2577 24.0425 15.0002 24.0211 14.7995 23.8613L14.7982 23.8603L11.4228 21.1816L11.4228 21.1816L11.4181 21.1779C11.2473 21.0441 11.1261 20.8117 11.1261 20.5363V16.1221V15.7806L10.9172 15.5104L1.26792 3.03399C1.26791 3.03399 1.26791 3.03398 1.2679 3.03398C0.98082 2.66275 0.915218 2.1332 1.11594 1.68494Z",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.12b57adac475643fdf2f3c574c229484.svg";
export { ForwardRef as ReactComponent };